<template>
  <div>
    <div class="d-flex align-center">
      <Breadcrumbs class="pa-2" head="Bảng điểm tổng kết"></Breadcrumbs>
      <div class="flex-fill"></div>
      <v-btn color="primary" v-if="canEdit" @click="onClickUpsertMarkSheet()">Tạo bảng điểm</v-btn>
    </div>

    <div class="marksheet-list">
      <BaseTableSkeletonLoader v-if="isLoadingMarkSheets"></BaseTableSkeletonLoader>
      <v-card v-else>
        <v-data-table
          :dense="true"
          item-key="id"
          disableSort
          :headers="headers"
          :items="tableData"
          item-class="row-class"
          :disable-pagination="true"
          :mobile-breakpoint="0"
          :hide-default-header="isEmpty"
          :hide-default-footer="true"
          @click:row="onRowClick"
        >
          <template v-slot:no-data="">
            <DataTableEmpty
              @create="onClickUpsertMarkSheet()"
              item="bảng điểm"
              text="Chưa có bảng điểm nào"
            ></DataTableEmpty>
          </template>
          <template v-slot:top="">
            <div class="d-flex pa-3 align-center">
              <span class="text-body-2"> Total: {{ tableData.length }} </span>
              <div class="flex-fill"></div>
              <div style="width: 240px">
                <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  type="search"
                  v-model="search"
                  dense
                  outlined
                  hide-details="auto"
                  clearable
                ></v-text-field>
              </div>
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <v-btn icon small>
                <v-icon small>mdi-eye</v-icon>
              </v-btn>
              <v-btn v-if="canEdit" icon small @click.stop="onClickDeleteMarkSheet(item)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:item.student_groups="{ item }">
            {{ item.student_groups.map(i => i.text).join(', ') }}
          </template>
        </v-data-table>
      </v-card>
    </div>
    <BaseDialog
      v-if="upsertMarkSheetDialog.isOpen"
      :isOpen="upsertMarkSheetDialog.isOpen"
      :title="upsertMarkSheetDialog.title"
      @close="upsertMarkSheetDialog.isOpen = false"
      @cancel="upsertMarkSheetDialog.onCancel"
      @confirm="upsertMarkSheetDialog.callback"
    >
      <v-form lazy-validation ref="upsertMarkSheetDialog">
        <v-card-text>
          <v-text-field
            autofocus
            label="Tiêu đề"
            v-model="upsertMarkSheetDialog.currentItem.title"
          ></v-text-field>
          <v-autocomplete
            item-text="text"
            :items="studentGroups"
            item-value="id"
            multiple
            v-model="upsertMarkSheetDialog.currentItem.student_groups"
            :rules="[$rules.required, $rules.minArrayLength(1)]"
            label="Nhóm lớp"
          >
          </v-autocomplete> </v-card-text
      ></v-form>
    </BaseDialog>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/basic/Breadcrumbs.vue'
import BaseTableSkeletonLoader from '@/components/base/BaseTableSkeletonLoader'

import { mapActions, mapState } from 'vuex'
import DataTableEmpty from '@/components/DataTableEmpty.vue'
import BaseDialog from '@/components/base/BaseDialog'
import { cloneDeep } from 'lodash'
export default {
  components: { Breadcrumbs, DataTableEmpty, BaseDialog, BaseTableSkeletonLoader },
  data() {
    return {
      search: '',
      upsertMarkSheetDialog: {
        currentItem: null,
        isOpen: false,
        title: '',
        valid: true,
        onCancel: () => {
          this.upsertMarkSheetDialog.isOpen = false
        },
        callback: () => {}
      }
    }
  },
  methods: {
    ...mapActions('marksheet', [
      'fetchOverallMarkSheets',
      'fetchSemesterConfigs',
      'fetchSemesterCourseConfigs',
      'createOverallMarkSheet',
      'createSemesterConfig',
      'createSemesterCourseConfig',
      'updateOverallMarkSheet',
      'updateSemesterConfig',
      'updateSemesterCourseConfig',
      'removeOverallMarkSheet',
      'removeSemesterConfig',
      'removeSemesterCourseConfig'
    ]),
    ...mapActions('studentGroup', ['fetchStudentGroups']),
    onRowClick(item) {
      this.$router.push(`/mark-sheets/${item.id}`)
    },
    onClickDeleteMarkSheet(item) {
      this.$dialog.confirm({
        title: 'Xóa bảng điểm',
        text: ` Bạn có Chắc Chắn xóa bảng điểm và các thông tin liên quan?`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          await this.removeOverallMarkSheet(item.id)
          this.$alert.success('Xóa thành công')
        }
      })
    },
    onClickUpsertMarkSheet(item) {
      this.upsertMarkSheetDialog.currentItem = item
        ? cloneDeep(item)
        : {
            title: 'Bảng điểm số ' + (this.tableData.length + 1),
            student_groups: []
          }
      this.upsertMarkSheetDialog.title = item ? 'Sửa bảng điểm' : 'Tạo bảng điểm'
      this.upsertMarkSheetDialog.isOpen = true
      this.upsertMarkSheetDialog.callback = (async () => {
        if (this.$refs.upsertMarkSheetDialog.validate()) {
          try {
            if (item) {
              await this.updateOverallMarkSheet(this.upsertMarkSheetDialog.currentItem)
              this.$alert.success('Cập nhật thành công')
            } else {
              await this.createOverallMarkSheet({ data: this.upsertMarkSheetDialog.currentItem })
              this.$alert.success('Tạo thành công')
            }
          } catch (error) {
            console.error(error)
            this.$alert.error('Có lỗi xay ra')
          } finally {
            this.upsertMarkSheetDialog.isOpen = false
          }
        }
      }).bind(this)
    }
  },
  computed: {
    ...mapState('marksheet', [
      'isLoadingMarkSheets',
      'overallMarkSheets',
      'semesterConfigs',
      'semesterCourseConfigs'
    ]),
    ...mapState('studentGroup', ['studentGroups']),
    ...mapState('auth', ['profile', 'role']),
    canEdit() {
      return ['super_admin', 'education_manager'].includes(this.role.type)
    },
    tableData() {
      return this.overallMarkSheets
        .map((i, index) => ({ ...i, index: index + 1 }))
        .filter(({ title, student_groups }) => {
          if (!this.search) {
            return true
          }
          let regex = new RegExp(this.search, 'i')
          if (title.match(regex)) {
            return true
          }
          regex = new RegExp(this.search.replace(/\s+/g, ' ').trim(), 'i')
          const studentGroupsText = student_groups.map(i => i.text).join(',')
          if (studentGroupsText.match(regex)) {
            return true
          }
          return false
        })
    },
    headers() {
      return [
        { text: 'STT', align: 'left', value: 'index' },
        { text: 'Tiêu đề', value: 'title' },
        { text: 'Nhóm lớp', value: 'student_groups' },
        { text: '', value: 'actions', width: 40 }
      ]
    },
    isEmpty() {
      return !this.tableData.length
    }
  },
  created() {
    this.fetchOverallMarkSheets()
    this.fetchStudentGroups()
  }
}
</script>
